import { Translation } from '@shared/types/translation';

export const EQUIPMENT_ERROR_MESSAGES = {
  SERIAL_NUMBER_DUPLICATE: {
    english: 'Serial number already exists',
    polish: 'Numer seryjny już istnieje',
  },
} as const satisfies Record<string, Translation>;
